import { Skeleton, Stack, Tabs, Text, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { useSearch } from '~/api/queries'
import { AlbumGrid } from '~/components/blocks/AlbumGrid/AlbumGrid'
import { ArtistGrid } from '~/components/blocks/ArtistGrid/ArtistGrid'
import { TrackTable } from '~/components/blocks/TrackTable/TrackTable'

const searchSchema = z.object({
  q: z.string().default(''),
})

export const Route = createFileRoute('/_app/search/')({
  validateSearch: searchSchema,
  component: SearchPage,
})

function SearchPage() {
  const { q } = Route.useSearch()
  const { data, isLoading } = useSearch(q)

  if (!q) {
    return (
      <Stack gap="md">
        <Title order={2}>Search</Title>
        <Text c="dimmed">Enter a search term to find artists, albums, and tracks.</Text>
      </Stack>
    )
  }

  return (
    <Stack gap="md">
      <Title order={2}>Results for "{q}"</Title>

      {isLoading ? (
        <Skeleton h={400} />
      ) : data ? (
        <Tabs defaultValue="tracks">
          <Tabs.List>
            <Tabs.Tab value="tracks">Tracks ({data.tracks.total})</Tabs.Tab>
            <Tabs.Tab value="albums">Albums ({data.albums.total})</Tabs.Tab>
            <Tabs.Tab value="artists">Artists ({data.artists.total})</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="tracks" pt="md">
            {data.tracks.data.length > 0 ? (
              <TrackTable tracks={data.tracks.data} />
            ) : (
              <Text c="dimmed">No tracks found.</Text>
            )}
          </Tabs.Panel>

          <Tabs.Panel value="albums" pt="md">
            {data.albums.data.length > 0 ? (
              <AlbumGrid albums={data.albums.data} />
            ) : (
              <Text c="dimmed">No albums found.</Text>
            )}
          </Tabs.Panel>

          <Tabs.Panel value="artists" pt="md">
            {data.artists.data.length > 0 ? (
              <ArtistGrid artists={data.artists.data} />
            ) : (
              <Text c="dimmed">No artists found.</Text>
            )}
          </Tabs.Panel>
        </Tabs>
      ) : null}
    </Stack>
  )
}
